module.exports = __webpack_public_path__ + "assets/sounds/cha-ching.mp3";